import {Routes} from '@angular/router';

export const releaseCashRoutes: Routes = [
  {
    path: 'release.cash',
    loadComponent: () => import('./release.cash.component').then(m => m.ReleaseCashComponent),
    data: {title: '预购商品兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.equity.cash',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '预购商品兑付明细' },
      },
      {
        path: 'add.equity.cash/:orderId',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '预购商品兑付明细' },
      },
    ]
  },
]
